import { Flex as AntdFlex } from '@empglabs/backoffice-ui-kit'

const Flex = props => {
  return <AntdFlex {...props} />
}

export default Flex

